import { helper } from '@ember/component/helper';

const noopString = 'javascript:void(0)';

export default helper(function isNoUrlHelper([ url ]) {
  url = url && `${url}`.trim();
  return Boolean(!url || url === noopString);
});
